import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {BonusBuyPopUpContent} from "@nolimitcity/promo-panel/bin/feature/generic/BonusBuyPopUpContent";
import {BrickSnake2000} from "../BrickSnake2000";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {BrickSnake2000GameData} from "../server/BrickSnake2000Data";
import {ASBonusPickOptions, ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {Label} from "@nolimitcity/slot-launcher/bin/gui/labels/Label";
import {BrickSnake2000GameAssets} from "../BrickSnake2000GameAssets";
import {RestoreUtils} from "../utils/RestoreUtils";
import GC_MAX_CHECK_COUNT = PIXI.settings.GC_MAX_CHECK_COUNT;

/**
 * Created by jonas on 2023-11-01.
 */

export class BrickSnake2000PromoPanelConfig implements PromoPanelGameConfiguration{

    private static hasShownBigWin:boolean = false;

    constructor() {
    }



    replaceBonusBuyPopUpContent(orgContent:BonusBuyPopUpContent):PIXI.Container {
        //You can modify the orgContent to your liking, like in the simple text replace below. All params is public in orgContent, it's basically a PIXI container with som stuff in.
        //Or you can make you your own container with everything custom. You don't need to return a BonusBuyPopUpContent, it's enough with a container.
        //Use the priceString if you change the price text, it's already formatted correctly.
        const featureShouldBeUsed = false;

        if (orgContent.featureName == "GOD_MODE" || orgContent.featureName == "GOD_MODE_DELUXE"){
            const warningTextText = orgContent.featureName == "GOD_MODE"
                                    ? "Warning: 1 Spin. No Win or Max Win!"
                                    : "50/50 chance to double your Max Win, or lose it all.";
            const warningText =
                new Label(BrickSnake2000.apiPlugin.translations.translate(warningTextText),
                          orgContent.textLabel.getStyleClone());
            const scale = Math.min(560 / warningText.width, 1);
            warningText.scale.set(scale, scale);
            warningText.anchor.set(0.5, 0.5);
            warningText.position.set(0, 420);
            orgContent.addChild(warningText);

            const godModeStillImage = orgContent.featureImage;
            const godModeSpine = new PIXI.spine.Spine(BrickSnake2000.assetLoader.getSpineAsset(BrickSnake2000GameAssets.GOD_MODE_POPUP))
            if (orgContent.featureName == "GOD_MODE")
                godModeSpine.state.setAnimation(0, "Loop", true);
            else
                godModeSpine.state.setAnimation(0, "Loop_2", true);
            godModeSpine.position.copyFrom(godModeStillImage);

            orgContent.featureImage = <PIXI.Sprite>(<any>godModeSpine);
            orgContent.removeChild(godModeStillImage);
            orgContent.addChild(godModeSpine);

        }

        return orgContent;
    }

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "BrickSnake2000",
            hasActionSpin: true,
            //This is for automatically picking no always.
            automaticPickGame: {
                header:()=> "", //BrickSnake2000.apiPlugin.translations.translate("Note: "),
                type:ASBonusPickOptions.PICK_MODE,
                optionSelection:()=>1,
                pickNeededForModes:["GAMBLE_FIFTY_FIFTY"],
                pickNeededForBuyFeatures:[]
            },
            //This is for playing 50/50 in game everytime.
            maxWin: {
                shouldPlayMaxWinInGame:(response: any) => {
                    const activeFeature = BrickSnake2000.apiPlugin.betFeatureController.getActiveBetFeature();
                    if (activeFeature?.name === "GOD_MODE_DELUXE"){
                        return false;
                    }
                    return true;
                },
                playMaxWinInGame: (response: any) => {
                    return new Promise<any>((resolve, reject) => {
                        //reset reels,
                        BrickSnake2000.apiPlugin.slotStates.resetGameStartedAndGameServerFlag();
                        BrickSnake2000.model.data = response;
                        RestoreUtils.restoreDoubleOrNothing();

                        (<any>BrickSnake2000.gameFlowController)._currentPresentationController.skip();

                        setTimeout(()=>{
                            BrickSnake2000.gameFlowController.start()
                        }, 300);

                        BrickSnake2000.apiPlugin.slotStates.stateIsReady().then(()=>{
                           resolve("")
                        });
                    });
                }
            },
            mainGame: {
                header: ()=>"xBET",
                options: [
                    {name:"NORMAL", id:0, image:"NORMAL.png"},
                    {name:"BOOSTED_BET" ,id:1, image:"BOOSTED_BET.png"}
                ],
                type: ASMainGamePickOptions.BOOSTED_BET
            },
            graphics: {
                backgroundTextureName: "resources/images/Intro_BG.jpg"
            },
            getParsedData: (response: BrickSnake2000GameData, bet: number, prevResponse: BrickSnake2000GameData):ASWinData => {
                // for reseting if we have shown any big wins or not per round
                if (prevResponse == undefined) {
                    BrickSnake2000PromoPanelConfig.hasShownBigWin = false;
                }

                return {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpins(response),
                    totalSpinWinnings: this.getTotalWin(response, prevResponse),
                    isBigWin: this.isBigWin(response, prevResponse),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response), //response.nextMode == GameMode.NORMAL,
                    isBonusEnd: this.isBonudEnd(response),
                    isWinCapHit: response.brokeTheBank,
                }
            }
        };
    }

    private getTotalWin(response: BrickSnake2000GameData, prevResponse:BrickSnake2000GameData):number {
        return this.isFreespinsMode(response)
               ? response.freespinsWinnings - prevResponse.freespinsWinnings
               : response.accumulatedRoundWin;
    }

    private isFreespinsMode(response:BrickSnake2000GameData):boolean {
        return response.mode == GameMode.FREESPIN || response.mode == GameMode.FREESPIN_SUPER;
    }

    private isFreeSpins(response:any){
        return response.mode == GameMode.NORMAL && (response.nextMode == GameMode.FREESPIN ||response.nextMode == GameMode.FREESPIN_SUPER)
    }

    private getWinSize(response:BrickSnake2000GameData) {
        return response.totalSpinWinnings;
    }

    private getFeatureName(response: BrickSnake2000GameData): string {
        if ((response.mode == GameMode.FREESPIN) || response.nextMode == GameMode.FREESPIN){
            return "SNEK SPINS";
        }

        if ((response.mode == GameMode.FREESPIN_SUPER) || response.nextMode == GameMode.FREESPIN_SUPER){
            return "SUPER SNEK SPINS";
        }

        if (response.mode == "GAMBLE_FIFTY_FIFTY"){
            return "DOUBLE OR NOTHING";
        }


        return response.mode;
    }

    private isBonudEnd(response: BrickSnake2000GameData):boolean {
        return response.mode != GameMode.NORMAL && response.nextMode == GameMode.NORMAL;
    }

    public onActionSpinPlaySound(trigger:ActionSpinSound):void {
        if (trigger == ActionSpinSound.WIN)
            BrickSnake2000.soundPlayer.playSound("asWin");
        else if (trigger == ActionSpinSound.BIG_WIN)
            BrickSnake2000.soundPlayer.playSound("asBigWin");
    }

    private isBigWin(response:BrickSnake2000GameData, prevResponse:BrickSnake2000GameData): boolean {
        const win = response.totalSpinWinnings;
        const fsWin = response.freespinsWinnings - prevResponse?.freespinsWinnings;

        if (response.wasFeatureBuy){
            const betPrice = BrickSnake2000.getBetPrice();
            const winToUse = (this.isFreespinsMode(response) &&
                              !(this.isBonudEnd(response) && !BrickSnake2000PromoPanelConfig.hasShownBigWin))
                             ? fsWin
                             : win;
            let winRatio: number = Helper.ceilToDecimals((winToUse / betPrice), 2);

            if (winRatio >= 1)
                BrickSnake2000PromoPanelConfig.hasShownBigWin = true;

            // do not show big win unless we got it for the individual spin or havent shown any big wins yet
            return winRatio >= 1;
        }

        let winRatio: number = Helper.ceilToDecimals((win / response.playedBetValue), 2);
        return winRatio >= 15;
    }

    private isRoundComplete(response: BrickSnake2000GameData): boolean {
        return  ([GameMode.FREESPIN,GameMode.FREESPIN_SUPER, GameMode.NORMAL].indexOf(response.nextMode) > -1);
    }


}